import api from './index';

export const apiGetLocals = async ({ offset, term }, companyId) => {
  try {
    const { data } = await api.get(
      `/companies/${companyId}/addresses?offset=${offset}&term=${term}`,
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiIncludeLocal = async (local, companyId) => {
  try {
    const { data } = await api.post(`/companies/${companyId}/addresses`, local);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getCityByNameAndState = async (stateID, nameCity) => {
  try {
    const { data } = await api.get(`/city/by-name/${stateID}/${nameCity}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiEditLocal = async (payload) => {
  const sendAdressId = (payload.address_detail && payload.address_detail.id) || payload.id;
  const sendCompanyId = (payload.address_detail && payload.address_detail.company_id) || payload.company_id;
  try {
    const { data } = await api.put(
      `/companies/${sendCompanyId}/addresses/${sendAdressId}`,
      payload.address_detail || payload,
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiDeleteLocal = async (local) => {
  try {
    const { data } = await api.delete(`/companies/${local.company_id}/addresses/${local.id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const checkIfIsAddressCompany = async (local, service_id) => {
  try {
    const { data } = await api.post('address/validate-from-company', { ...local, service_id });
    return data;
  } catch (error) {
    throw error;
  }
};
